import React, { useState, useRef, useEffect } from "react";
import CardDetail from "./CardDetail";
import DisplayCard from "./DisplayCard";
import PersonalCard from "./PersonalCard";
import InformationCard from "./InformationCard";
import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import { v4 as uuid } from "uuid";
import {
  createCard,
  dataLookUpConst,
  getAllLookUp,
  uploadImage,
  validateDataCard,
} from "../constants";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const AddCard = () => {
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errrorMsg, setErrorMsg] = useState("");
  const [prefix, setPrefix] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [suffix, setSuffix] = useState("");

  const [dataLookup, setDataLookup] = useState(dataLookUpConst);

  const names = [
    { label: "Prefix", value: prefix, funcSet: setPrefix },
    { label: "First name*", value: firstName, funcSet: setFirstName },
    { label: "Middle name", value: middleName, funcSet: setMiddleName },
    { label: "Last name*", value: lastName, funcSet: setLastName },
    { label: "Suffix", value: suffix, funcSet: setSuffix },
  ];

  const [cardName, setCardName] = useState("");
  const [cardId, setCardId] = useState(uuid().replace(/-/g, ""));
  let initialMsg =
    "Hi! Glad we could connect 😊 Here's my contact information so we can stay in touch and get to know each other better: {{link}}. Feel free to reach out anytime!";
  const [introMsg, setIntroMsg] = useState(initialMsg);
  const [cardActive, setCardActive] = useState(true);
  const cardsDetails = [
    { label: "Card Name*", value: cardName, funcSet: setCardName },
    { label: "Card Id*", value: cardId, funcSet: setCardId },
    { label: "Introduction Message", value: introMsg, funcSet: setIntroMsg },
    { label: "Active", value: cardActive, funcSet: setCardActive },
  ];

  const [imageSourceHeader, setImageSourceHeader] = useState("");
  const [imageSourceProfile, setImageSourceProfile] = useState("");
  const [imageSourceLogo, setImageSourceLogo] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [company, setCompany] = useState("");
  const [aboutMe, setAboutMe] = useState("");
  const onButtonClick = (type) => {
    // `current` points to the mounted file input element
    if (type == "header") {
      inputFile1.current.click();
    } else if (type == "profile") {
      inputFile2.current.click();
    } else {
      inputFile3.current.click();
    }
  };
  const onDeletePhoto = (type) => {
    // `current` points to the mounted file input element
    if (type == "header") {
      setImageSourceHeader(null);
    } else if (type == "profile") {
      setImageSourceProfile(null);
    } else {
      setImageSourceLogo(null);
    }
  };

  const occupations = [
    { label: "Job Title*", value: jobTitle, funcSet: setJobTitle },
    { label: "Company", value: company, funcSet: setCompany },
    { label: "About me", value: aboutMe, funcSet: setAboutMe },
  ];
  const [indexColorTheme, setIndexColorTheme] = useState(0);
  const user = JSON.parse(localStorage.getItem("user_info"));
  const [aspect, setAspect] = useState(1);
  const email = user.email;
  const token = user.access_token;
  const [imageEdit, setImageEdit] = useState(null);
  const [funcSetEdit, setFuncSetEdit] = useState(() => setImageSourceHeader);
  const [informations, setInformations] = useState([
    {
      lookup_id: "LKP8d00ffb749ce4cb4a26236888b7614e2",
      category: "card_social",
      label: "email",
      display_label: "E-mail",
      base_url: null,
      placeholder: null,
      type: null,
      values: "personal,work",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG3fc615fefaf54b07b630877d32847e07.svg",
      created_at: "2025-07-18T19:37:33.669626",
      updated_at: "2025-07-18T19:37:33.669626",
      value: email,
      options: null,
      value_option: null,
      validation: true,
    },
  ]);

  const inputFile1 = useRef(null);
  const inputFile2 = useRef(null);
  const inputFile3 = useRef(null);
  const [circularCrop, setCircularCrop] = useState(true);
  const handleOnChangeImage = (event, type) => {
    event.preventDefault();
    let file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    if (type == "header") {
      setFuncSetEdit(() => setImageSourceHeader);
      setAspect(2);
      setCircularCrop(false);
    } else if (type == "profile") {
      setFuncSetEdit(() => setImageSourceProfile);
      setAspect(1);
      setCircularCrop(true);
    } else {
      setFuncSetEdit(() => setImageSourceLogo);
      setAspect(1);
      setCircularCrop(false);
    }
    reader.addEventListener("load", () => {
      const imageUrl = reader.result?.toString() || "";
      setImageEdit(imageUrl);
    });
    reader.readAsDataURL(file);
    document.getElementById("edit_photo_modal").showModal();
  };
  const [colorThemes, setColorThemes] = useState(
    dataLookup.Display["Color Theme"].map((v, ind) => ({
      color1: "#" + v.values.split(",")[0],
      color2: "#" + v.values.split(",")[1],
      name: v.display_label,
      id: v.lookup_id,
    })),
  );
  const [colorFirst, setColorFirst] = useState(colorThemes[0].color1);
  const [colorSecond, setColorSecond] = useState(colorThemes[0].color2);
  const [sections, setSections] = useState([
    "Card",
    "Display",
    "Personal",
    "Information",
  ]);
  const [indexTemplate, setIndexTemplate] = useState(0);
  const [templates, setTemplates] = useState(
    dataLookup.Display["Card Template"].map((v, i) => ({
      img: v.image_url,
      name: v.display_label,
      id: v.lookup_id,
    })),
  );
  const [activeSection, setActiveSection] = useState(sections[0]);

  const navigate = useNavigate();

  const handleOnClickAddCard = async (e) => {
    e.preventDefault();
    setLoading(true);
    let data = {
      about_me: aboutMe,
      card_name: cardName,
      card_social: informations.map((val, ind) => ({
        chosen_value: val.value_option,
        display_text: val.display_text ? val.display_text : null,
        input_value: val.value,
        lookup_id: val.lookup_id,
      })),
      card_template_id: templates[indexTemplate].id,
      company: company,
      first_name: firstName,
      intro_message: introMsg,
      is_active: cardActive,
      job_title: jobTitle,
      last_name: lastName,
      middle_name: middleName,
      prefix: prefix,
      slug: cardId,
      suffix: suffix,
    };
    if (indexColorTheme <= 4) {
      data.color_theme_id = colorThemes[indexColorTheme].id;
    } else {
      data.color_theme_custom =
        colorFirst.replace("#", "") + "," + colorSecond.replace("#", "");
    }
    if (imageSourceHeader) {
      const header_image_id = await uploadImage(
        token,
        imageSourceHeader,
        "card_header",
      );
      data.header_image_id = header_image_id;
    }

    if (imageSourceProfile) {
      const profile_image_id = await uploadImage(
        token,
        imageSourceProfile,
        "card_profile",
      );
      data.profile_image_id = profile_image_id;
    }

    if (imageSourceLogo) {
      const logo_image_id = await uploadImage(
        token,
        imageSourceLogo,
        "card_logo",
      );
      data.logo_image_id = logo_image_id;
    }

    let err = informations
      .filter((val) => !val.validation)
      .map((val, ind) => val.display_label);

    if (err.length > 0) {
      const errorsInformation = err.join(", ");
      toast.error(errorsInformation, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }

    err = validateDataCard(data);
    if (err != "") {
      toast.error(err, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }

    createCard(token, data, setLoading, setShowError, setErrorMsg, navigate);
    // setLoading(false);
  };

  useEffect(() => {
    getAllLookUp(token, setColorThemes, setTemplates, setDataLookup);
  }, []);

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [showError]);

  return (
    <div className="flex flex-col md:flex-row w-full bg-white h-full overflow-y-auto md:overflow-y-hidden">
      <ToastContainer />
      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-1/2 max-w-[500px] px-5 py-5 gap-3 items-center md:overflow-y-hidden">
        {indexTemplate == 0 ? (
          <Card1
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        ) : indexTemplate == 1 ? (
          <Card2
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        ) : (
          <Card3
            colorFirst={colorFirst}
            colorSecond={colorSecond}
            imageSourceHeader={imageSourceHeader}
            imageSourceLogo={imageSourceLogo}
            imageSourceProfile={imageSourceProfile}
            prefix={prefix}
            suffix={suffix}
            firstName={firstName}
            middleName={middleName}
            lastName={lastName}
            jobTitle={jobTitle}
            company={company}
            aboutMe={aboutMe}
            informations={informations}
          />
        )}

        <div
          className="px-10 py-2 bg-primary text-white shadow-lg hover:bg-tertiary active:translate-y-1 cursor-pointer rounded-lg"
          onClick={handleOnClickAddCard}
          id="AddCard"
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Add Card"
          )}
        </div>
      </div>
      <div className="flex flex-col w-full h-full divide-y-[1px] divide-gray-200">
        <div className="flex flex-row w-full" id="cardForm">
          {sections.map((v, i) => (
            <div
              className={`px-5 py-4 cursor-pointer hover:font-bold ${
                activeSection == v ? "font-bold hover:text-secondary" : ""
              }`}
              key={i}
              id={v}
              onClick={() => setActiveSection(v)}
            >
              {v}
            </div>
          ))}
        </div>
        <div className="flex flex-col w-full justify-start items-start overflow-y-auto h-[74vh]">
          {activeSection == "Card" ? (
            <CardDetail cardsDetails={cardsDetails} />
          ) : activeSection == "Display" ? (
            <DisplayCard
              templates={templates}
              indexTemplate={indexTemplate}
              setIndexTemplate={setIndexTemplate}
              colorThemes={colorThemes}
              setColorThemes={setColorThemes}
              setColorSecond={setColorSecond}
              setColorFirst={setColorFirst}
              inputFile1={inputFile1}
              inputFile2={inputFile2}
              inputFile3={inputFile3}
              handleOnChangeImage={handleOnChangeImage}
              onButtonClick={onButtonClick}
              onDeletePhoto={onDeletePhoto}
              imageSourceHeader={imageSourceHeader}
              imageSourceProfile={imageSourceProfile}
              setImageSourceProfile={setImageSourceProfile}
              imageSourceLogo={imageSourceLogo}
              indexColorTheme={indexColorTheme}
              setIndexColorTheme={setIndexColorTheme}
              imageEdit={imageEdit}
              funcSetEdit={funcSetEdit}
              aspect={aspect}
              circularCrop={circularCrop}
            />
          ) : activeSection == "Personal" ? (
            <PersonalCard names={names} occupations={occupations} />
          ) : (
            <InformationCard
              informations={informations}
              setInformations={setInformations}
              Information={dataLookup.Information}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCard;
